import React from 'react';
import ExerciseResults from '../shared/ExerciseResults';
import ExerciseCard from '../shared/ExerciseCard';
import DiaryNoteSection from '../diary/DiaryNoteSection';

const Results = ({ exercises, userAnswers, restart, onBack, topic }) => {
  // Calculate score
  const correctAnswers = exercises.filter(ex =>
    userAnswers[ex.id] === ex.correct_answer
  ).length;

  const totalQuestions = exercises.length;

  return (
    <ExerciseResults
      title="Výsledky - Gramatika"
      score={correctAnswers}
      total={totalQuestions}
      color="purple"
      onRestart={restart}
      onBack={onBack}
      diarySection={(
        <DiaryNoteSection
          topic={topic}
          exerciseType="grammar_fillin"
        />
      )}
    >
      {/* Detailed Results */}
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Detailní výsledky
      </h3>

      <div className="flex flex-col gap-3">
        {exercises.map((exercise, index) => {
          const userAnswer = userAnswers[exercise.id];
          const isCorrect = userAnswer === exercise.correct_answer;
          const parts = exercise.sentence.split('____');

          return (
            <div
              key={exercise.id}
              className={`p-4 rounded-lg ${
                isCorrect
                  ? 'bg-green-50'
                  : 'bg-red-50'
              }`}
            >
              <div className="flex items-start gap-3">
                <span className="text-purple-600 font-semibold min-w-[30px]">
                  #{index + 1}
                </span>
                <div className="flex-1">
                  <div className="text-gray-700 mb-2">
                    {parts[0]}
                    <strong className={`${
                      isCorrect ? 'text-green-600' : 'text-red-500 line-through'
                    }`}>
                      {userAnswer}
                    </strong>
                    {parts[1]}
                  </div>
                  {!isCorrect && (
                    <div className="text-sm text-gray-600">
                      <strong>Správná odpověď:</strong> {exercise.correct_answer}
                    </div>
                  )}
                  <div className={`text-sm font-medium mt-2 ${
                    isCorrect ? 'text-green-600' : 'text-red-500'
                  }`}>
                    {isCorrect ? '✓ Správně' : '✗ Špatně'}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </ExerciseResults>
  );
};

export default Results;
